module.exports = __webpack_public_path__ + "img/ico_write_short.f9e5222.svg";